import React, { Component } from 'react';
import { ListItem, ListItemText, ListItemIcon, Typography, Button, TableRow, TableCell, TableBody } from '@material-ui/core';
import { Close, List, Create, BallotRounded } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { TableLayout } from '../Stock/containers/Layout';
var $ = require('jquery');

class ProfileBoxItemBoxStatus extends Component{
    state = {

            //Initiate Time for the chart
            BoxInfoStatus: 'pmb-block',
            MenuBoxInfoStatus: 'dropdown',

            idBox: '',
            addressMac: '',
            ipAdress: '',
            status: '',
            lastConnexion: '',
            lastError: '',
            version: ''
        }
    showMenuBoxInfo(e) {
        e.preventDefault();
        this.props.reloadInfo();
        if (this.state.MenuBoxInfoStatus === 'dropdown open') {
            this.setState({MenuBoxInfoStatus: 'dropdown'});
        } else {
            this.setState({MenuBoxInfoStatus: 'dropdown'});
            //this.setState({MenuBoxInfoStatus: 'dropdown open'});
        }
    }
    showEditMenuBoxInfo(e) {
        e.preventDefault();
        this.setState({MenuBoxInfoStatus: 'dropdown', BoxInfoStatus: 'pmb-block toggled'});
    }
    closeBoxInfo(e) {
        e.preventDefault();
        this.setState({MenuBoxInfoStatus: 'dropdown', BoxInfoStatus: 'pmb-block'});
    }
    componentDidMount() {
        var methodName = 'Get Box Info';
        var urlBoxFreeOfAssociation = "/box/info?boxAssoId=" + this.props.boxAssoId;

        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO], ', methodName);
            console.log(result);
            var idBox = '';
            var addressMac = '';
            var ipAdress = '';
            var status = '';
            var lastConnexion = '';
            var lastError = '';
            var version = '';
            try {
                var data = result; //var data = JSON.parse(result);
                idBox = data.idBox;
                addressMac = data.addressMac;
                ipAdress = data.ipAdress;
                status = data.status;
                lastConnexion = data.lastConnexion;
                lastError = data.lastError;
                version = data.version;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({
                idBox: idBox,
                addressMac: addressMac,
                ipAdress: ipAdress,
                status: status,
                lastConnexion: lastConnexion,
                lastError: lastError,
                version: version
            });
        }.bind(this));
    }

    render() {

        return (
            <MiniCard
                title="Caractéristiques de la Box"
                avatar={<BallotRounded />}
            >
                <TableLayout>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th">Numero de la Box</TableCell>
                            <TableCell>{this.state.idBox}</TableCell>
                        </TableRow>
                        {this.state.addressMac !== "" &&
                            <TableRow>
                                <TableCell component="th">Adress Mac de la Box</TableCell>
                                <TableCell>{this.state.addressMac}</TableCell>
                            </TableRow>
                        }
                        {this.state.addressMac == "" &&
                        
                            <TableRow>
                                <TableCell component="th">Adresse IP</TableCell>
                                <TableCell>{this.state.ipAdress}</TableCell>
                            </TableRow>
                        }
                        {this.state.status !== "NoConnection" &&
                        
                            <TableRow>
                                <TableCell component="th">Status</TableCell>
                                <TableCell>{this.state.status}</TableCell>
                            </TableRow>
                        }
                        {this.state.lastConnexion !== "0001-01-01T00:00:00Z" &&
                            <TableRow>
                                <TableCell component="th">Dernière connexion</TableCell>
                                <TableCell>{this.state.lastConnexion}</TableCell>
                            </TableRow>
                        }
                        {this.state.lastError && 
                            <TableRow>
                                <TableCell component="th">Dernière erreur</TableCell>
                                <TableCell>{this.state.lastError}</TableCell>
                            </TableRow>
                        }
                        {this.state.version &&
                            <TableRow>
                                <TableCell component="th">Version</TableCell>
                                <TableCell>{this.state.version}</TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </TableLayout>
            </MiniCard>
                   
        )
    }
};
export default ProfileBoxItemBoxStatus
